import { render, staticRenderFns } from "./MainStructure.vue?vue&type=template&id=07314eb9&scoped=true&"
import script from "./MainStructure.vue?vue&type=script&lang=js&"
export * from "./MainStructure.vue?vue&type=script&lang=js&"
import style0 from "./MainStructure.vue?vue&type=style&index=0&id=07314eb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07314eb9",
  null
  
)

export default component.exports